export default class InvalidAssignationException extends Error {
  constructor(message, routeIdentifier, tripIdentifier) {
    super(message);
    this.routeIdentifier = routeIdentifier;
    this.tripIdentifier = tripIdentifier;
  }
}
